import { actions } from "../../utils/constants";


const initialState = {
    loading: false,
    data: [],

}
const productCategoryReducer = (state = initialState, action) => {

    switch (action.type) {
        case actions.START_PRODUCT_CATEGORY_LOADING: return { ...state, loading: true, data: [] };
        case actions.SET_PRODUCT_CATEGORY_DATA: return { ...state, loading: false, data: action.value };
        default: return { ...state }
    }

}
export default productCategoryReducer